import StaticLanguagePage from '../StaticLanguagePage';
import spanishPageData from './spanishPageData';

export default function SpanishStaticPage() {
  return <StaticLanguagePage language={spanishPageData} />;
}
